import React from 'react';
import { Box, Container, Link, Typography } from '@mui/material';
import { CONTACT, LANDING_COLORS } from '../../content/landingContent';

/** Red accent link with horizontal line prefix */
const RedActionLink = ({ href, children, external = true }) => (
  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, mt: 2 }}>
    <Box sx={{ width: 28, height: 1, bgcolor: LANDING_COLORS.redLink, flexShrink: 0 }} />
    <Link
      href={href}
      target={external ? '_blank' : undefined}
      rel={external ? 'noopener noreferrer' : undefined}
      sx={{
        fontFamily: 'Cabin, sans-serif',
        fontSize: 14,
        color: LANDING_COLORS.redLink,
        fontWeight: 400,
        '&:hover': { color: '#b82221' },
      }}
    >
      {children}
    </Link>
  </Box>
);

const ContactOfficeSection = () => (
  <Box id="contact" component="section" sx={{ py: { xs: 6, md: 10 }, bgcolor: '#fff' }}>
    <Container maxWidth="lg">
      <Box
        sx={{
          display: 'grid',
          gridTemplateColumns: { xs: '1fr', md: '1fr 1fr' },
          gap: { xs: 4, md: 8 },
          alignItems: 'start',
        }}
      >
        {/* Left — headline */}
        <Typography
          sx={{
            fontFamily: 'Cabin, sans-serif',
            fontWeight: 700,
            fontSize: { xs: 26, md: 36 },
            color: '#000',
            lineHeight: 1.25,
            maxWidth: 480,
          }}
        >
          {CONTACT.title}
        </Typography>

        {/* Right — address + contact columns */}
        <Box
          sx={{
            display: 'grid',
            gridTemplateColumns: { xs: '1fr', sm: '1fr 1fr' },
            gap: { xs: 4, sm: 4, md: 6 },
          }}
        >
          <Box>
            <Typography
              sx={{
                fontFamily: 'Cabin, sans-serif',
                fontWeight: 700,
                fontSize: 16,
                color: '#000',
                mb: 1.5,
              }}
            >
              Ofis Adresimiz
            </Typography>
            <Typography
              sx={{
                fontFamily: 'Cabin, sans-serif',
                fontSize: 15,
                color: LANDING_COLORS.textGray,
                lineHeight: 1.6,
              }}
            >
              {CONTACT.address}
            </Typography>
            <RedActionLink href={CONTACT.directionsUrl}>{CONTACT.directionsLabel}</RedActionLink>
          </Box>

          <Box>
            <Typography
              sx={{
                fontFamily: 'Cabin, sans-serif',
                fontWeight: 700,
                fontSize: 16,
                color: '#000',
                mb: 1.5,
              }}
            >
              İletişim
            </Typography>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5 }}>
              <Link
                href={`mailto:${CONTACT.email}`}
                sx={{
                  fontFamily: 'Cabin, sans-serif',
                  fontSize: 15,
                  color: LANDING_COLORS.textGray,
                  textDecoration: 'none',
                  '&:hover': { color: '#000' },
                }}
              >
                {CONTACT.email}
              </Link>
              <Link
                href={`tel:${CONTACT.phone.replace(/\s/g, '')}`}
                sx={{
                  fontFamily: 'Cabin, sans-serif',
                  fontSize: 15,
                  color: LANDING_COLORS.textGray,
                  textDecoration: 'none',
                  '&:hover': { color: '#000' },
                }}
              >
                {CONTACT.phone}
              </Link>
              <Link
                href={`https://${CONTACT.website}`}
                target="_blank"
                rel="noopener noreferrer"
                sx={{
                  fontFamily: 'Cabin, sans-serif',
                  fontSize: 15,
                  color: LANDING_COLORS.textGray,
                  textDecoration: 'none',
                  '&:hover': { color: '#000' },
                }}
              >
                {CONTACT.website}
              </Link>
            </Box>
            <RedActionLink href={CONTACT.meetingUrl}>{CONTACT.meetingLabel}</RedActionLink>
          </Box>
        </Box>
      </Box>
    </Container>
  </Box>
);

export default ContactOfficeSection;
